export const SET_CTA_ACTION = 'SET_CTA_ACTION';
export const SET_CTA_ACTION_SUCCESS = 'SET_CTA_ACTION_SUCCESS';
export const SET_CTA_ACTION_FAILURE = 'SET_CTA_ACTION_FAILURE';
export const RESET_CTA_ACTION = 'RESET_CTA_ACTION';

export const GET_ORDERS_LIST_DATA = 'ORDERSLIST:GET_LIST_DATA';
export const GET_ORDERS_LIST_DATA_SUCCESS = 'ORDERSLIST:GET_LIST_DATA_SUCCESS';
export const GET_ORDERS_LIST_DATA_FAILURE = 'ORDERSLIST:GET_LIST_DATA_FAILURE';

export const GET_ALL_ORDERS_LIST_DATA = 'ORDERSLIST:GET_ALL_LIST_DATA';
export const GET_ALL_ORDERS_LIST_DATA_SUCCESS =
    'ORDERSLIST:GET_ALL_ORDERS_LIST_DATA_SUCCESS';
export const GET_ALL_ORDERS_LIST_DATA_FAILURE =
    'GET_ALL_ORDERS_LIST_DATA_FAILURE';

export const RESET_ORDER_LIST = 'ORDERSLIST:RESET_ORDER_LIST';

//Two Calls Helper actions
export const ORDERS_LIST_FILTERS_UPDATE =
    'ORDERSLIST:ORDERS_LIST_FILTERS_UPDATE';
export const ORDERS_LIST_DATA_UPDATE = 'ORDERSLIST:ORDERS_LIST_DATA_UPDATE';
export const FILTER_AND_ORDERLIST_UPDATE =
    'ORDERSLIST:FILTER_AND_ORDERLIST_UPDATE';

//Order List Views
export const GET_DISTRICT = 'APPLIEDORDERFILTER:GET_DISTRICT';
export const GET_DISTRICT_SUCCESS = 'APPLIEDORDERFILTER:GET_DISTRICT_SUCCESS';
export const GET_DISTRICT_FAILURE = 'APPLIEDORDERFILTER:GET_DISTRICT_FAILURE';
export const SET_DISTRICT = 'APPLIEDORDERFILTER:SET_DISTRICT';

export const GET_TERRITORY = 'APPLIEDORDERFILTER:GET_TERRITORY';
export const GET_TERRITORY_SUCCESS = 'APPLIEDORDERFILTER:GET_TERRITORY_SUCCESS';
export const GET_TERRITORY_FAILURE = 'APPLIEDORDERFILTER:GET_TERRITORY_FAILURE';
export const SET_TERRITORY = 'APPLIEDORDERFILTER:SET_TERRITORY';
export const RESET_TERRITORY = 'APPLIEDORDERFILTER:RESET_TERRITORY';

export const GET_ACCOUNTS = 'APPLIEDORDERFILTER:GET_ACCOUNTS';
export const GET_ACCOUNTS_SUCCESS = 'APPLIEDORDERFILTER:GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_FAILURE = 'APPLIEDORDERFILTER:GET_ACCOUNTS_FAILURE';
export const SET_ACCOUNTS = 'APPLIEDORDERFILTER:SET_ACCOUNTS';
export const RESET_ACCOUNTS = 'APPLIEDORDERFILTER:RESET_ACCOUNTS';
//Order List Filters
import axios from 'axios';
//Fetch order summary data
export const GET_ORDERS_SUMMARY = 'ORDERSLIST:GET_ORDERS_SUMMARY';
export const GET_ORDERS_SUMMARY_SUCCESS =
    'ORDERSLIST:GET_ORDERS_SUMMARY_SUCCESS';
export const GET_ORDERS_SUMMARY_FAILURE =
    'ORDERSLIST:GET_ORDERS_SUMMARY_FAILURE';

export const GET_CHECK_ORDER_ACTION_ELIGIBILITY = 'GET_CHECK_ORDER_ACTION_ELIGIBILITY';
export const GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS = 'GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS';
export const GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE = 'GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE';
export const GET_CHECK_ORDER_ACTION_ELIGIBILITY_RESET= 'GET_CHECK_ORDER_ACTION_ELIGIBILITY_RESET';

//Set and get the send report modal state
export const SET_SEND_REPORT_MODAL_STATE =
    'ORDERSLIST:SET_SEND_REPORT_MODAL_STATE';
export const SHOW_HIDE_SEND_REPORT_MODAL =
    'ORDERSLIST:SHOW_HIDE_SEND_REPORT_MODAL';

//Set the Descrepency Image modal state
export const SET_DESCREPENCY_IMAGE_VIEW =
    'DESCREPENCY:SET_DESCREPENCY_IMAGE_VIEW';

//To open order summary modal state
export const SET_ORDER_SUMMARY_MODAL_STATE =
    'ORDERSSUMMARY:SET_ORDER_SUMMARY_MODAL_STATE';

//To open report procedure modal state
export const SET_REPORT_PROCEDURE_MODAL_STATE =
    'ORDERSLIST:SET_REPORT_PROCEDURE_MODAL_STATE';

//To Close order summary modal state
export const CLOSE_ORDER_SUMMARY_MODAL_STATE =
    'ORDERSSUMMARY:CLOSE_ORDER_SUMMARY_MODAL_STATE';
export const SHOW_HIDE_SUMMARY_MODAL = 'ORDERSSUMMARY:SHOW_HIDE_SUMMARY_MODAL';
export const SHOW_HIDE_REQUEST_INVOICE = 'SHOW_HIDE_REQUEST_INVOICE';

export const SET_ORDER_STATE = 'ORDERSSUMMARY:SET_ORDER_STATE';

export const SHOW_HIDE_SAVEASTEMPLATE =
    'ORDERSSUMMARY:SHOW_HIDE_SAVEASTEMPLATE';
export const SET_ORDERSUMMARY_TAB = 'ORDERSSUMMARY:SET_ORDERSUMMARY_TAB';

//Send usage report
export const SEND_USAGE_REPORT = 'ORDERSLIST:SEND_USAGE_REPORT';
export const SEND_USAGE_REPORT_SUCCESS = 'ORDERSLIST:SEND_USAGE_REPORT_SUCCESS';
export const SEND_USAGE_REPORT_FAILURE = 'ORDERSLIST:SEND_USAGE_REPORT_FAILURE';
export const RESET_SEND_USAGE_REPORT_STATUS =
    'ORDERSLIST:RESET_SEND_USAGE_REPORT_STATUS';

//Set search values
export const SET_SEARCH_PARAMS = 'ORDERSLIST:SET_SEARCH_PARAMS';
export const SHOW_ORDER_FILTER = 'ORDERFILTER:SHOW_ORDER_FILTER';
export const CLOSE_ORDER_FILTER = 'ORDERFILTER:CLOSE_ORDER_FILTER';
export const TOGGLE_ORDER_FILTERS = 'ORDERFILTER:TOGGLE_ORDER_FILTERS';
export const CATEGORY_SELECTED = 'ORDERFILTER:CATEGORY_SELECTED';
export const QUICK_FILTER_SELECTED = 'ORDERFILTER:QUICK_FILTER_SELECTED';
export const SET_ORDERS_LOADING = 'ORDERFILTER:SET_ORDERS_LOADING';
//Dispatch Filter Type
export const SET_FILTER_TYPE = 'ORDERFILTER:SET_FILTER_TYPE';
export const SET_CATEGORY_FILTER = 'ORDERFILTER:SET_CATEGORY_FILTER';

//Set Order Filter Dates
export const SET_ORDERS_DATE_FILTER = 'ORDERSLIST:SET_ORDERS_DATE_FILTER';

//Set Legacy mobile Filter dropdown
export const SET_LEGACY_MOBILE_FILTER_DROPDOWN_VALUE =
    'ORDERSLIST:SET_LEGACY_MOBILE_FILTER_DROPDOWN_VALUE';

//Reset Persist Filter
export const ORDER_LIST_FILTER_RESET =
    'ORDERSLISTFILTER:ORDER_LIST_FILTER_RESET';
//Reset Persist Applied Filter
export const ORDER_LIST_APPLIED_FILTER_RESET =
    'ORDERSLISTFILTER:ORDER_LIST_APPLIED_FILTER_RESET';
//Set Filters
export const SET_FILTERS = 'ORDERSLISTFILTER:SET_FILTERS';
export const SET_ORDER_LIST_FLITER_ORDERSTATUS =
    'ORDERSLISTFILTER:SET_ORDER_LIST_FLITER_ORDERSTATUS';
export const SET_APPLY_FILTER = 'ORDERSLISTFILTER:SET_APPLY_FILTER';
export const FILTERS_UPDATE = 'ORDERSLISTFILTER:FILTERS_UPDATE';
export const DENIED_TOGGLE_FILTER = 'ORDERSLISTFILTER:DENIED_TOGGLE_FILTER';
export const DENIED_OVERRIDE_TOGGLE_CLICK = 'ORDERSLISTFILTER:DENIED_OVERRIDE_TOGGLE_CLICK';

//Set Category
export const SET_CATEGORY = 'ORDERFILTER:SET_CATEGORY';

//Set Quick Filter
export const SET_QUICKFILTER = 'ORDERFILTER:SET_QUICKFILTER';

//Set Applied Filters
export const SET_APPLIED_VIEW_ORDER_FILTER =
    'ORDERFILTER:SET_APPLIED_VIEW_ORDER_FILTER';
export const RESET_APPLIED_ORDER_FILTER =
    'ORDERFILTER:RESET_APPLIED_ORDER_FILTER';

//Restore Order Filter Snapshot (atomic restore of CC user orders state after impersonation)
export const RESTORE_ORDER_FILTER_SNAPSHOT =
    'ORDERFILTER:RESTORE_ORDER_FILTER_SNAPSHOT';

//Get Search results
export const GET_SEARCH_RESULTS_ORDERS_LIST_DATA =
    'ORDERSLIST:GET_SEARCH_RESULTS_ORDERS_LIST_DATA';
export const GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS =
    'ORDERSLIST:GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS';
export const GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE =
    'ORDERSLIST:GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE';
export const SHOW_HIDE_SEARCH_ORDER_LIST =
    'ORDERSLIST:SHOW_HIDE_SEARCH_ORDER_LIST';
export const TOGGLE_SEARCH_ORDER_MODAL = 'ORDERSLIST:TOGGLE_SEARCH_ORDER_MODAL';
export const TOGGLE_TABLE_SEARCH_LOADER =
    'ORDERSLIST:TOGGLE_TABLE_SEARCH_LOADER';

//Get Refined results
export const GET_REFINED_ORDERS_LIST_DATA =
    'ORDERSLIST:GET_REFINED_ORDERS_LIST_DATA';
export const GET_REFINED_ORDERS_LIST_DATA_SUCCESS =
    'ORDERSLIST:GET_REFINED_ORDERS_LIST_DATA_SUCCESS';
export const GET_REFINED_ORDERS_LIST_DATA_FAILURE =
    'ORDERSLIST:GET_REFINED_ORDERS_LIST_DATA_FAILURE';
export const GET_DENIED_ORDER = 'ORDERSLIST:GET_DENIED_ORDER';
export const GET_DENIED_ORDER_SUCCESS = 'ORDERSLIST:GET_DENIED_ORDER_SUCCESS';
export const GET_DENIED_ORDER_FAILURE = 'ORDERSLIST:GET_DENIED_ORDER_FAILURE';
export const GET_DENIED_ORDER_FILTER = 'ORDERSLIST:GET_DENIED_ORDER_FILTER';
export const GET_DENIED_ORDER_FILTER_SUCCESS = 'ORDERSLIST:GET_DENIED_ORDER_FILTER_SUCCESS';
export const GET_DENIED_ORDER_FILTER_FAILURE = 'ORDERSLIST:GET_DENIED_ORDER_FILTER_FAILURE';
export const SET_DENIED_OVERRIDE_CLICKED =
    'ORDERSLIST:SET_DENIED_OVERRIDE_CLICKED';

//delete order
export const DELETE_ORDER = 'ORDERSLIST:DELETE_ORDER';
export const DELETE_ORDER_SUCCESS = 'ORDERSLIST:DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAILURE = 'ORDERSLIST:DELETE_ORDER_FAILURE';
export const SHOW_DELETE_ORDER = 'ORDERSLIST:SHOW_DELETE_ORDER';

//view usage report
export const VIEW_REPORT_SHOW_HIDE = 'ORDERSLIST:VIEW_REPORT_SHOW_HIDE';
export const VIEW_REPORT = 'ORDERSLIST:VIEW_REPORT';
export const VIEW_REPORT_SUCCESS = 'ORDERSLIST:VIEW_REPORT_SUCCESS';
export const VIEW_REPORT_FAILURE = 'ORDERSLIST:VIEW_REPORT_FAILURE';
export const VIEW_REPORT_RESET = 'ORDERSLIST:VIEW_REPORT_RESET';
export const VIEW_REPORT_HISTORY = 'ORDERSLIST:VIEW_REPORT_HISTORY';
//view usage report pdf
export const VIEW_PDF_REPORT = 'ORDERSLIST:VIEW_PDF_REPORT';
export const VIEW_REPORT_PDF_SUCCESS = 'ORDERSLIST:VIEW_REPORT_PDF_SUCCESS';
export const VIEW_REPORT_PDF_FAILURE = 'ORDERSLIST:VIEW_REPORT_PDF_FAILURE';
export const RESET_VIEW_PDF_REPORT = 'ORDERSLIST:RESET_VIEW_PDF_REPORT';

//view usage report
export const SEND_INVOICE = 'ORDERSLIST:SEND_INVOICE';
export const PROCEDURE = 'PROCEDURE:GET_PROCEDURE_DONE';
export const SEND_INVOICE_SUCCESS = 'ORDERSLIST:SEND_INVOICE_SUCCESS';
export const SEND_INVOICE_FAILURE = 'ORDERSLIST:SEND_INVOICE_FAILURE';
export const OPEN_POPOVER = 'OPEN_POPOVER';
export const RESET_INVOICE = 'ORDERSLIST:RESET_INVOICE';

export const GET_UNID_URL = 'GET_UNID_URL';
export const DENIED_TOGGLE_TEMP = 'DENIED_TOGGLE_TEMP';
export const GET_UNID_URL_SUCCESS = 'GET_UNID_URL_SUCCESS';
export const GET_UNID_URL_FAILURE = 'GET_UNID_URL_FAILURE';
export const DELETE_UNID_URL = 'DELETE_UNID_URL';

export const SET_DYNAMIC_Z_INDEX = 'SET_DYNAMIC_Z_INDEX';

export const SET_SHOW_EXPANDED_VIEW = 'SET_SHOW_EXPANDED_VIEW';
export const SET_SHOW_EXPANDED_FILTER = 'SET_SHOW_EXPANDED_FILTER';

export const SET_SHOW_EXPANDED_SEARCH_PANEL = 'SET_SHOW_EXPANDED_SEARCH_PANEL';

export const SUBMIT_PROCEDURE_DATA = 'SUBMIT_PROCEDURE_DATA';
export const SUBMIT_PROCEDURE_DATA_SUCCESS = 'SUBMIT_PROCEDURE_DATA_SUCCESS';
export const SUBMIT_PROCEDURE_DATA_FAILURE = 'SUBMIT_PROCEDURE_DATA_FAILURE';
export const RESET_SUBMIT_PROCEDURE_DATA = 'RESET_SUBMIT_PROCEDURE_DATA';
export const SHOW_HIDE_REPORT_PROCEDURE_MODAL =
    'SHOW_HIDE_REPORT_PROCEDURE_MODAL';
export const AWAITING_PO_TOGGLE = 'ORDERSLIST:AWAITING_PO_TOGGLE';
export const DENIED_TOGGLE = 'ORDERSLIST:DENIED_TOGGLE';
export const AWAITING_PO_TOGGLE_MOBILE = 'ORDERSLIST:AWAITING_PO_TOGGLE_MOBILE';
export const RESET_AWAITING_PO_TOGGLE = 'ORDERSLIST:RESET_AWAITING_PO_TOGGLE';
export const RESET_AWAITING_PO_TOGGLE_MOBILE =
    'ORDERSLIST:RESET_AWAITING_PO_TOGGLE_MOBILE';
export const SET_ITEM_LIST_VIEW =
    'ORDERSLIST:SET_ITEM_LIST_VIEW';
export const SET_IMPLANT_AND_INSTRUMENT_PRODUCTS = 'ORDERSLIST:SET_IMPLANT_AND_INSTRUMENT_PRODUCTS';
//Event Notification Retrigger
export const SET_NOTIFICATION_FAILURE_LIST='FILTER: SET_NOTIFICATION_FAILURE_LIST';
export const RETRIGGER_EVENT_NOTIFICATION='RETRIGGER_EVENT_NOTIFICATION';
export const SET_NOTIFICATION_FAILURE_RESPONSE='SET_NOTIFICATION_FAILURE_RESPONSE';

export const TERRITORY_CREDIT = "TERRITORY_CREDIT";
export const TERRITORY_CREDIT_SUCCESS = "TERRITORY_CREDIT_SUCCESS";
export const TERRITORY_CREDIT_FAILURE = "TERRITORY_CREDIT_FAILURE";

export const SAVE_TERRITORY_CREDIT = "SAVE_TERRITORY_CREDIT";
export const SAVE_TERRITORY_CREDIT_SUCCESS = "SAVE_TERRITORY_CREDIT_SUCCESS";
export const SAVE_TERRITORY_CREDIT_FAILURE = "SAVE_TERRITORY_CREDIT_FAILURE";
export const RESET_SAVE_TERRITORY_CREDIT = "RESET_SAVE_TERRITORY_CREDIT";
//To Get orderlist data
export const getOrderListData = (orderListParams) => {
    return {
        type: GET_ORDERS_LIST_DATA,
        payload: orderListParams,
    };
};

export const setCtaData = (params) =>{
    return{
        type: SET_CTA_ACTION,
        payload: params,
    };
};

export const resetCtaData = () =>{
    return{
        type:RESET_CTA_ACTION,
    };
};

// To get all order List data
export const getAllOrderListData = (orderListParams) => {
    return {
        type: GET_ALL_ORDERS_LIST_DATA,
        payload: orderListParams,
    };
};

//Show Hide Search Modal;
export const showHideSearchModalAction = (searchToggle) => {
    return {
        type: SHOW_HIDE_SEARCH_ORDER_LIST,
        data: searchToggle,
    };
};
export const showHideProcedureModalAction = (searchToggle) => {
    return {
        type: SHOW_HIDE_REPORT_PROCEDURE_MODAL,
        payload: searchToggle,
    };
};
export const toggleSearchResult = (searchToggle) => {
    return {
        type: TOGGLE_SEARCH_ORDER_MODAL,
        data: searchToggle,
    };
};
export const toggleTableSearchLoader = (loaderValue) => {
    return {
        type: TOGGLE_TABLE_SEARCH_LOADER,
        data: loaderValue,
    };
};
//To get serach result
export const getSearchOrderListData = (searchValues) => {
    return {
        type: GET_SEARCH_RESULTS_ORDERS_LIST_DATA,
        payload: searchValues,
    };
};

// to get refined order Result based on filters
export const getRefinedOrderListData = (filters, isDeniedOverride = false) => {
    return {
        type: GET_REFINED_ORDERS_LIST_DATA,
        payload: filters,
        isDeniedOverride: isDeniedOverride,
    };
};
export const getDeniedOrder = (filters, isDeniedOverride = false) => {
    return {
        type: GET_DENIED_ORDER,
        payload: filters,
        isDeniedOverride: isDeniedOverride,
    };
};

export const getDeniedOrderFilter = (filters) => {
    return {
        type: GET_DENIED_ORDER_FILTER,
        payload: filters,
    };
};

export const setDeniedOverrideClicked = (value) => {
    return {
        type: SET_DENIED_OVERRIDE_CLICKED,
        payload: value,
    };
};
//quickFilter Count Zero Reset
export const actionResetOrderList = () => {
    return {
        type: RESET_ORDER_LIST,
    };
};

export const setOrdersListFilter = (ordersFilter) => {
    return {
        type: SET_FILTERS,
        payload: ordersFilter,
    };
};

export const setLegacyMobileFilterDropdownAction = (filterOption) => {
    return {
        type: SET_LEGACY_MOBILE_FILTER_DROPDOWN_VALUE,
        data: filterOption,
    };
};

export const setOrderDateAction = (orderDates) => {
    return {
        type: SET_ORDERS_DATE_FILTER,
        data: orderDates,
    };
};
export const setNotificationFailure=(list)=>
{
    return{
        type:SET_NOTIFICATION_FAILURE_LIST,
        payload:list,
    };
};
export const getOrderSummaryData = () => {
    return {
        type: GET_ORDERS_SUMMARY,
    };
};

export const getCheckOrderActionEligibility = (payload) => {
    return {
        type: GET_CHECK_ORDER_ACTION_ELIGIBILITY,
        payload,
    };
};

export const getCheckOrderActionEligibilityReset = () =>{
    return{
        type:GET_CHECK_ORDER_ACTION_ELIGIBILITY_RESET
    };
};

export const showHideSendReportAction = (modalState) => {
    return {
        type: SHOW_HIDE_SEND_REPORT_MODAL,
        payload: modalState,
    };
};

export const setSendReportModalState = (modalState) => {
    return {
        type: SET_SEND_REPORT_MODAL_STATE,
        payload: modalState,
    };
};

export const setDescrepencyImageViewState = (modalState) => {
    return {
        type: SET_DESCREPENCY_IMAGE_VIEW,
        payload: modalState,
    };
};

export const setOrderSummaryModalState = (modalState) => {
    return {
        type: SET_ORDER_SUMMARY_MODAL_STATE,
        payload: modalState,
    };
};
export const getProcedureDone = () => {
    return {
        type: PROCEDURE,
    };
};

export const fetchOrderSummary = (params) => async (dispatch) => {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/summary?${params}`;
    
    try {
        const response = await axios.get(url);
        dispatch({
            type: 'GET_ORDERS_SUMMARY_SUCCESS',
            data: response.data, // Use 'data' to match your reducer
        });
        return response.data; // Return backend response
    } catch (error) {
        dispatch({
            type: 'GET_ORDERS_SUMMARY_FAILURE',
            statusCode: error.response?.status,
            statusMessage: error.message,
        });
        throw error;
    }
};
export const setReportProcedureModalState = (modalState) => {
    return {
        type: SET_REPORT_PROCEDURE_MODAL_STATE,
        payload: modalState,
    };
};
export const setOrderStatus = (data) => {
    return {
        type: SET_ORDER_STATE,
        payload: data.orderStatus,
    };
};
export const closeOrderSummaryModalState = (modalState) => {
    return {
        type: CLOSE_ORDER_SUMMARY_MODAL_STATE,
        payload: modalState,
    };
};

export const showHideSummaryModal = (modalState) => {
    return {
        type: SHOW_HIDE_SUMMARY_MODAL,
        payload: modalState,
    };
};

export const showHideSaveAsTemplateAction = (saveAsTemplateState) => {
    return {
        type: SHOW_HIDE_SAVEASTEMPLATE,
        data: saveAsTemplateState,
    };
};

export const setOrderSummaryTabAction = (tabType) => {
    return {
        type: SET_ORDERSUMMARY_TAB,
        data: tabType,
    };
};

export const showHideRequestInvoice = (modalState) => {
    return {
        type: SHOW_HIDE_REQUEST_INVOICE,
        payload: modalState,
    };
};
export const sendReport = (reportDetails) => {
    return {
        type: SEND_USAGE_REPORT,
        payload: reportDetails,
    };
};
export const triggerEventNotification = (data,flag=false) => {
    return {
        type: RETRIGGER_EVENT_NOTIFICATION,
        payload: data,
        flag:flag,
    };
};

export const showOrderFilter = () => {
    return {
        type: SHOW_ORDER_FILTER,
    };
};

export const closeOrderFilter = () => {
    return {
        type: CLOSE_ORDER_FILTER,
    };
};
export const toggleOrderFilter = () => {
    return {
        type: TOGGLE_ORDER_FILTERS,
    };
};

export const setCategoryFilter = (category) => {
    return {
        type: CATEGORY_SELECTED,
        payload: category,
    };
};

export const setSearchParams = (searchValues) => {
    return {
        type: SET_SEARCH_PARAMS,
        payload: searchValues,
    };
};

export const getDistrict = (data) => {
    return {
        type: GET_DISTRICT,
        payload: data,
    };
};
export const getTerritory = (district) => {
    return {
        type: GET_TERRITORY,
        payload: district,
    };
};
export const getAccounts = (accountParams) => {
    return {
        type: GET_ACCOUNTS,
        payload: accountParams,
    };
};

export const resetAccounts = () => {
    return {
        type: RESET_ACCOUNTS,
    };
};
export const resetTerritory = () => {
    return {
        type: RESET_TERRITORY,
    };
};

export const setCategory = (categoryId) => {
    return {
        type: SET_CATEGORY,
        payload: categoryId,
    };
};

export const setFilterOrderStatus = (orderStatusList) => {
    return {
        type: SET_ORDER_LIST_FLITER_ORDERSTATUS,
        payload: orderStatusList,
    };
};

export const setQuickFilter = (quickFilterName) => {
    return {
        type: QUICK_FILTER_SELECTED,
        payload: quickFilterName,
    };
};

export const setAppliedFilter = (appliedFilters) => {
    return {
        type: SET_APPLIED_VIEW_ORDER_FILTER,
        payload: appliedFilters,
    };
};

export const actionApplyFilterType = (filterType) => {
    return {
        type: SET_FILTER_TYPE,
        payload: filterType,
    };
};

export const actionCategoryFilters = (filtersList) => {
    return {
        type: SET_CATEGORY_FILTER,
        payload: filtersList,
    };
};

//to delete an order
export const deleteOrder = (myCaseRef) => {
    return {
        type: DELETE_ORDER,
        payload: myCaseRef,
    };
};

export const showDeleteOrderAction = (isShowDelete) => {
    return {
        type: SHOW_DELETE_ORDER,
        payload: isShowDelete,
    };
};

export const showHideViewReportAction = (showHideViewReport) => {
    return {
        type: VIEW_REPORT_SHOW_HIDE,
        payload: showHideViewReport,
    };
};

export const resetSendUsageReportAction = () => {
    return {
        type: VIEW_REPORT_RESET,
    };
};

//to view usage report
export const viewReport = (
    myCaseRefNum,
    pricingParam,
    reportOptionParam,
    sendType
) => {
    return {
        type: VIEW_REPORT,
        payload: {
            myCaseRef: myCaseRefNum,
            pricing: pricingParam,
            reportOption: reportOptionParam,
            isEmail: sendType === 'isEmail' ? true : false,
        },
    };
};
export const viewPdfReport = (
    myCaseRefNum,
    pricingParam,
    reportOptionParam
) => {
    return {
        type: VIEW_PDF_REPORT,
        payload: {
            myCaseRef: myCaseRefNum,
            pricing: pricingParam,
            reportOption: reportOptionParam,
        },
    };
};
export const resetViewPdfReport = () => {
    return {
        type: RESET_VIEW_PDF_REPORT,
    };
};
//To send invoice
export const sendInvoice = (invoiceParams) => {
    return {
        type: SEND_INVOICE,
        payload: invoiceParams,
    };
};
export const resetInvoiceAction = () => {
    return {
        type: RESET_INVOICE,
    };
};
export const openFilterPopover = (isSet) => {
    return {
        type: OPEN_POPOVER,
        payload: isSet,
    };
};

export const getUnidUrl = (unidID) => {
    return {
        type: GET_UNID_URL,
        payload: unidID,
    };
};

export const deniedToggleTemp = (value) => {
    return {
        type: DENIED_TOGGLE_TEMP,
        payload: value,
    };
};

export const deleteUnidUrl = () => {
    return {
        type: DELETE_UNID_URL,
    };
};
//Two Calls Helper Action
export const refineFilterAndOrderList = (
    filtersList,
    isFilterApplied = false,
    toggleEnabled=false,
) => {
    return {
        type: FILTER_AND_ORDERLIST_UPDATE,
        payload: filtersList,
        isFilterApplied: isFilterApplied,
        toggleEnabled: toggleEnabled
    };
};

export const setDynamicZIndex = (dynamicZIndex) => {
    return {
        type: SET_DYNAMIC_Z_INDEX,
        payload: dynamicZIndex,
    };
};

export const setShowExpandedView = (updatedView) => {
    return {
        type: SET_SHOW_EXPANDED_VIEW,
        payload: updatedView,
    };
};

export const setShowExpandedFilter = (updatedFilter) => {
    return {
        type: SET_SHOW_EXPANDED_FILTER,
        payload: updatedFilter,
    };
};

export const setShowExpandedSearchPanel = (updatedSearchPanel) => {
    return {
        type: SET_SHOW_EXPANDED_SEARCH_PANEL,
        payload: updatedSearchPanel,
    };
};

export const setOrdersLoading = (loaderValue) => {
    return {
        type: SET_ORDERS_LOADING,
        payload: loaderValue,
    };
};
export const submitProcedureData = (data) => {
    return {
        type: SUBMIT_PROCEDURE_DATA,
        payload: data,
    };
};
export const resetOrderListFilter = () => {
    return {
        type: ORDER_LIST_FILTER_RESET,
    };
};

export const resetAppliedOrderListFilter = () => {
    return {
        type: ORDER_LIST_APPLIED_FILTER_RESET,
    };
};

/**
 * Atomically restore Orders and Applied Orders filter state from impersonation snapshot.
 * Dispatched to both reducers for consistency; reduces re-renders vs. multiple dispatches.
 */
export const restoreOrderFilterSnapshot = (snapshot) => {
    return {
        type: RESTORE_ORDER_FILTER_SNAPSHOT,
        payload: snapshot,
    };
};

export const awaitingToggle = (payload) => {
    return {
        type: AWAITING_PO_TOGGLE,
        payload: payload,
    };
};
export const deniedToggle = (payload) => {
    return {
        type: DENIED_TOGGLE,
        payload: payload,
    };
};
export const resetAwaitingToggle = (payload) => {
    return {
        type: RESET_AWAITING_PO_TOGGLE,
        payload: payload,
    };
};

export const awaitingToggleMobile = (payload) => {
    return {
        type: AWAITING_PO_TOGGLE_MOBILE,
        payload: payload,
    };
};

export const resetAwaitingToggleMobile = (payload) => {
    return {
        type: RESET_AWAITING_PO_TOGGLE_MOBILE,
        payload: payload,
    };
};

export const deniedToggleFilter = (toggle) => {
    return {
        type: DENIED_TOGGLE_FILTER,
        data: toggle,
    };
};
export const deniedOverrideToggleClickChange = (value) => {
    return {
        type: DENIED_OVERRIDE_TOGGLE_CLICK,
        payload: value,
    };
};

export const setItemListView = (value) => {
    return {
        type: SET_ITEM_LIST_VIEW,
        payload: value,
    };
};

export const setImplantableAndInstrumentProducts = (data) => ({
    type: SET_IMPLANT_AND_INSTRUMENT_PRODUCTS,
    payload: data,
});

// export const onDistrictChange = (district) => {
//     return{
//         type: SET_DISTRICT
//     };
// };
// export const onTerritoryChange = (territory) => {
//     return{
//         type: SET_TERRITORY,
//         payload: territory
//     };
// };
// export const onAccountChange = (account) => {
//     return{
//         type: SET_ACCOUNT,
//         payload: account
//     };
// };

export const getTerritoryCredit = (sstRef) => {
    return {
        type: TERRITORY_CREDIT,
        payload: sstRef,
    };
};

export const saveTerritoryCredit = (territoryCreditParams) => {
    return {
        type: SAVE_TERRITORY_CREDIT,
        payload: territoryCreditParams,
    };
};

export const resetSaveTerritoryCredit = () => {
    return {
        type: RESET_SAVE_TERRITORY_CREDIT,
    };
};
